import { render, staticRenderFns } from "./FollowUpDialog.vue?vue&type=template&id=70180127"
import script from "./FollowUpDialog.vue?vue&type=script&lang=js"
export * from "./FollowUpDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports